module.exports = __webpack_public_path__ + "img/stent2_second.2d83897f.png";